export default "__VITE_ASSET__BRwO146W__"